import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/facebook-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-137.3v-152.3h57.8l11-71.7h-68.8v-46.5c0-19.6 9.6-38.7 40.4-38.7h31.3v-61s-28.4-4.8-55.5-4.8c-56.7 0-93.7 34.3-93.7 96.5v54.6h-63v71.7h63v152.3h-137.3c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/facebook-square.js
// module id = 818
// module chunks = 0